import { LanguageOutlined, Public as PublicIcon } from "@mui/icons-material";
import { IconButton, Link as MuiLink, Stack, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

import { Route } from "~services/router/Route";

const tPublicPage = "Open CrowdCoursing public page";
const tWebsite = "Visit website";

export interface MyOrganizationLinkIconsProps {
  publicPagesEnabled?: boolean;
  slug?: string | null;
  website?: string | null;
}

export function MyOrganizationLinkIcons({ publicPagesEnabled = false, slug, website }: MyOrganizationLinkIconsProps) {
  const websiteUrl = website?.trim();
  const publicPageSlug = slug?.trim();
  const showPublicPage = publicPagesEnabled && Boolean(publicPageSlug);
  const showWebsite = Boolean(websiteUrl);

  if (!showWebsite && !showPublicPage) {
    return null;
  }

  return (
    <Stack direction="row" spacing={0.25} sx={{ flexShrink: 0 }}>
      {showWebsite ? (
        <Tooltip title={tWebsite}>
          <IconButton
            aria-label={tWebsite}
            component={MuiLink}
            href={websiteUrl}
            rel="noopener noreferrer"
            size="small"
            target="_blank"
          >
            <LanguageOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
      {showPublicPage ? (
        <Tooltip title={tPublicPage}>
          <IconButton
            aria-label={tPublicPage}
            component={Link}
            rel="noopener noreferrer"
            size="small"
            target="_blank"
            to={Route.publicOrg({ slug: publicPageSlug ?? "" })}
          >
            <PublicIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Stack>
  );
}
